export default {"src":"/_next/static/media/brand-career.44fecbf2.svg","height":48,"width":109,"blurWidth":0,"blurHeight":0};